/**
 * Тексты экрана обновления — обычными строками, а не через макросы Lingui.
 *
 * Причина та же, по которой так сделан `PushOnboarding`, и она именно в порядке монтирования:
 * компонент висит в `PlatformBridge`, то есть выше и раньше активации каталога переводов
 * (он приезжает динамическим импортом). Пока каталог не активен, макрос `t` подставляет вместо
 * текста идентификатор — у онбординга это уже случалось, человек читал хеши. Экран блокировки
 * тем более обязан быть читаемым в любом состоянии приложения: он и появляется тогда, когда
 * всё остальное сломано. Ключуем по активной локали, худший случай — английский текст.
 *
 * (В APK каталог лежит локально и «умереть при выкате», как на вебе, не может — эта, веб-ская,
 * причина здесь ни при чём, чтобы её потом не переносили в другие места по ошибке.)
 *
 * Формулировки — от последствия для человека, а не от механизма: «приложение больше не
 * работает с сервером» понятно, «версия ниже minVersion» — нет.
 */
export const UPDATE_COPY = {
  en: {
    bannerTitle: 'A new version is available',
    bannerDesc: 'Update to get the latest fixes and features.',
    bannerAction: 'Update',
    // Play не отдаёт наружу прогресс загрузки, поэтому и текст без процентов: обещать шкалу,
    // которой нет, хуже, чем честное «идёт».
    bannerDownloading: 'Downloading…',
    bannerRestart: 'Restart to install',
    bannerDismiss: 'Later',
    blockTitle: 'Please update the app',
    blockDesc:
      'This version no longer works with the server. Update from the store to keep playing – it only takes a moment.',
    blockAction: 'Update',
    blockRetry: 'Check again',
  },
  ru: {
    bannerTitle: 'Доступна новая версия',
    bannerDesc: 'Обновитесь, чтобы получить свежие исправления и возможности.',
    bannerAction: 'Обновить',
    bannerDownloading: 'Загружается…',
    bannerRestart: 'Перезапустить',
    bannerDismiss: 'Позже',
    blockTitle: 'Нужно обновить приложение',
    blockDesc:
      'Эта версия больше не работает с сервером. Обновитесь в магазине приложений – это займёт минуту.',
    blockAction: 'Обновить',
    blockRetry: 'Проверить снова',
  },
} as const;

export type UpdateCopy = (typeof UPDATE_COPY)['en'];

/**
 * Тексты экрана «идут работы» — обычными строками, по той же причине, что и тексты выше:
 * компонент висит в `PlatformBridge`, то есть выше каталога переводов, и макрос подставил бы
 * идентификатор вместо фразы. Экран, который появляется, когда всё остальное недоступно,
 * обязан быть читаемым в любом состоянии приложения.
 *
 * Причина работ приезжает с сервера и показывается как есть — её пишет человек в админке на
 * своём языке. Текста «попробуйте позже» здесь нет намеренно: экран пробует сам.
 */
export const MAINTENANCE_COPY = {
  en: {
    title: 'We are updating Teamplay',
    desc: 'The app will be back on its own – no need to restart it.',
    until: 'Expected back around',
    action: 'Check now',
  },
  ru: {
    title: 'Обновляем Teamplay',
    desc: 'Приложение вернётся само – перезапускать не нужно.',
    until: 'Ждём обратно примерно в',
    action: 'Проверить сейчас',
  },
} as const;
